



































import Vue from "vue";
import Component from "vue-class-component";
import { Emit } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";

export interface JobsearchListingSearchParams {
  code?: string;
  portal_office_name?: string;
  hst_no?: string;
  kst_no?: string;
  listing_no?: string;
  listing_title?: string;
}

@Component({
  components: {
    AppTextField,
  },
})
export default class extends Vue {
  private code = "";
  private portal_office_name = "";
  private hst_no = "";
  private kst_no = "";
  private listing_no = "";
  private listing_title = "";

  @Emit()
  private search(): JobsearchListingSearchParams {
    const params: JobsearchListingSearchParams = {
      code: this.code,
      portal_office_name: this.portal_office_name,
      hst_no: this.hst_no,
      kst_no: this.kst_no,
      listing_no: this.listing_no,
      listing_title: this.listing_title,
    };
    return params;
  }
}
